<template>
  <section class="max-w-screen-md mx-auto">
    <h1>What is Lightbucket?</h1>
    <p>
      Lightbucket is a tool for tracking your astrophotography imaging sessions so
      you can easily see data about your journey through the cosmos.
    </p>

    <h2 class="mt-8">How does Lightbucket work?</h2>
    <p>
      Lightbucket integrates directly with
      <a
        class="text-yellow-300 cursor-pointer"
        href="https://nighttime-imaging.eu/"
        target="_blank"
        rel="noopener noreferrer"
      >
        N.I.N.A.
      </a>
      through the plugin system to automatically log whenever an exposure finishes.
      The plugin logs information about the target, the image parameters, and the
      equipment used to give you a complete view of your imaging sessions.
    </p>

    <h2 class="mt-8">Is Lightbucket finished?</h2>
    <p>
      Not even close! Lightbucket is currently in beta mode and you can expect new
      features and changes to appear over time. Stay tuned for updates!
    </p>

    <h2 class="mt-8">Credits</h2>
    <p>
      Thank you to
      <a
        class="text-yellow-300 cursor-pointer"
        href="https://www.instagram.com/photosdibari/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Nicholas Di Bari
      </a>
      for the logo!
    </p>
  </section>
</template>
